import { useEffect, useState } from 'react'

/**
 * Polls `/version.json` and returns the deployed version once it differs
 * from the one this page was loaded with (`null` while they match). The
 * loaded version is read once, at the first successful poll, so every later
 * deployment is reported, not only the first one.
 */
export function useAppVersionCheck(interval: number = 30000) {
  const [newerVersion, setNewerVersion] = useState<string | null>(null)

  useEffect(() => {
    let currentVersion: string | null = null

    const checkVersion = async () => {
      try {
        const res = await fetch('/version.json', { cache: 'no-store' })
        if (!res.ok) return

        const data: { version: string } = await res.json()
        if (!currentVersion) {
          currentVersion = data.version
        } else if (currentVersion !== data.version) {
          setNewerVersion(data.version)
        }
      } catch (err) {
        console.warn('Version check failed:', err)
      }
    }

    const id = setInterval(checkVersion, interval)
    checkVersion()

    return () => clearInterval(id)
  }, [interval])

  const reload = () => {
    window.location.reload()
  }

  return { updateAvailable: newerVersion !== null, newerVersion, reload }
}
